import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const brandList = (payload) => ({
    type: actionTypes.BRAND_LIST_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const brandListSuccess = (payload) => ({
    type: actionTypes.BRAND_LIST_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const brandListFailure = (payload) => ({
    type: actionTypes.BRAND_LIST_FAILURE,
    payload,
});

export const brandListReset = () => ({
    type: actionTypes.BRAND_LIST_RESET,
});

// Action creator for resetting all OTP generation reducer
export const brandListResetAll = () => ({
    type: actionTypes.BRAND_LIST_RESET_ALL,
});
